"use client";

import { setSession } from "@lib/sessionStore";
import { deleteLoginBonusCookie } from "@lib/utils";
import { AUTH_TOKEN_REFRESH_ERROR } from "app/api/auth/[...nextauth]/authOptions";
import { useToast } from "app/hooks";
import { SessionProvider, signOut, useSession } from "next-auth/react";
import { useEffect } from "react";

export function SessionStoreComponent() {
  return (
    <SessionProvider>
      <SessionStoreComponentMain />
    </SessionProvider>
  );
}

function SessionStoreComponentMain() {
  const { status: sessionStatus, data: session, update: updateSession } = useSession();
  const { pushToast } = useToast();

  useEffect(() => {
    if (session?.error && session.error === AUTH_TOKEN_REFRESH_ERROR) {
      signOut({ redirect: false }).then(() => {
        //TODO:一旦明示してみるが暗黙的にサインアウトのほうがよいかもしれないので要検討
        pushToast("セッションの更新に失敗しました。再度ログインしてください。", {
          type: "error",
        });
        deleteLoginBonusCookie();
      });
      return;
    }
    setSession({
      sessionStatus,
      session,
      updateSession,
    });
  }, [sessionStatus, session, updateSession]);
  return <></>;
}
